import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SectoresService } from '../../services/sectores.service';
import { IAnalisisItem } from '../../interfaces/sector.interface';
import { SessionService } from '@shared/helpers/sesion.service';

@Component({
  selector: 'app-analisis-form',
  templateUrl: './analisis-form.component.html',
  providers: [MessageService]
})
export class AnalisisFormComponent implements OnInit, OnChanges {
  @Input() model: IAnalisisItem | null = null;
  @Input() sector: string = '';
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();

  form: FormGroup;
  loading: boolean = false;
  loadingVariables: boolean = false;
  variables: any[] = [];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private sectoresService: SectoresService,
    private sessionService: SessionService
  ) {
    this.initForm();
  }

  initForm(): void {
    this.form = this.fb.group({
      iVariable: [''],
      sDescripcion: [''],
      variableSeleccionada: ['']
    });
  }

  ngOnInit(): void {
    this.loadVariables();
    if (this.model) {
      this.form.patchValue({
        iVariable: this.model.iVariable,
        sDescripcion: this.model.sDescripcion,
        variableSeleccionada: this.model.numero_relacion
      });
      this.form.get('iVariable')?.disable();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      if (changes['model'].currentValue) {
        this.loadAnalisis();
      } else {
        this.initForm();
      }
    }
  }

  loadAnalisis(): void {
    if (!this.model) return;
    
    this.form.patchValue({
      iVariable: this.model.iVariable,
      sDescripcion: this.model.sDescripcion,
      variableSeleccionada: this.model.numero_relacion
    });
    this.form.get('iVariable')?.disable();
  }

  loadVariables(): void {
    this.loadingVariables = true;
    
    const request = {
      que: 4,
      tope: "9999",
      cmd: "",
      numero_relacion: 0,
      tipo: "",
      descripcion: "",
      formula: "",
      periodicidad: "",
      tipoVariable: ""
    };

    this.sectoresService.getRelaciones(request).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.variables = response.data.map((item: any) => ({
            label: `${item.numero_relacion} | ${item.tipo} | ${item.descripcion}`,
            value: item.numero_relacion,
            item: item
          }));
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar las variables'
          });
        }
        this.loadingVariables = false;
      },
      error: (error) => {
        console.error('Error al cargar variables:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar las variables'
        });
        this.loadingVariables = false;
      }
    });
  }

    onSubmit(): void {
    this.loading = true;
    
    const formData = this.form.getRawValue();
    
    const request = {
      sUsuario: this.sessionService.getUserSession() || '',
      iAccion: this.model ? 2 : 0, // 0 = Add, 2 = Update
      sSector: this.sector,
      iVariable: formData.iVariable,
      sDescripcion: formData.sDescripcion,
      iNumRel: formData.variableSeleccionada
    };

    const serviceCall = this.model 
      ? this.sectoresService.updateAnalisis(request)
      : this.sectoresService.addAnalisis(request);

    serviceCall.subscribe({
      next: (response) => {
        this.loading = false;
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: this.model ? 'Análisis actualizado correctamente' : 'Análisis creado correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al guardar el análisis'
          });
        }
      },
      error: (error) => {
        console.error('Error al guardar análisis:', error);
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al guardar el análisis'
        });
      }
    });
  }

  onCancel(): void {
    this.onSave.emit({
      success: false,
      message: 'Operación cancelada'
    });
  }
}
